import { apiInterfaceForJson } from '../common/apiManager';

export const fetchFlags = () => {
    return apiInterfaceForJson('/flag/v1/', 'GET');
};

export const getFlagById = (flagId) => {
    return apiInterfaceForJson(`/flag/v1/${flagId}`, 'GET');
};

export const createFlag = (flagData) => {
    return apiInterfaceForJson('/flag/v1/', 'POST', flagData);
};

export const updateFlag = (flagId, flagData) => {
    return apiInterfaceForJson(`/flag/v1/${flagId}`, 'PUT', flagData);
};

export const deleteFlag = (flagId) => {
    return apiInterfaceForJson(`/flag/v1/${flagId}`, 'DELETE');
};

export const getFlagsByAnalyte = (analyteId) => {
    return apiInterfaceForJson(`/flag/v1/analyte/${analyteId}`, 'GET');
};

export const evaluateFlag = (flagId, evaluationData) => {
    return apiInterfaceForJson(`/flag/v1/${flagId}/evaluate`, 'POST', evaluationData);
};